module.exports = __webpack_public_path__ + "img/organizations_details.0367d600.svg";